// platform/src/components/mw/MwProductTile.tsx
//
// Tile grande del producto: eyebrow + título + descripción + mockup
// visual. Hover lift coherente con MwFeatureCard. Tokens desde mw.css.

import { useState, type ReactNode, type CSSProperties } from 'react'

interface MwProductTileProps {
  eyebrow: string
  title: string
  description: string
  mockup: ReactNode
  className?: string
}

export function MwProductTile({
  eyebrow,
  title,
  description,
  mockup,
  className = '',
}: MwProductTileProps) {
  const [hovered, setHovered] = useState(false)

  const style: CSSProperties = {
    background: 'var(--mw-surface)',
    borderColor: hovered ? 'var(--mw-border-strong)' : 'var(--mw-border)',
    transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
    boxShadow: hovered ? 'var(--mw-shadow-card-hover)' : 'var(--mw-shadow-card)',
    transition:
      'transform var(--mw-duration-medium) var(--mw-ease), box-shadow var(--mw-duration-medium) var(--mw-ease), border-color var(--mw-duration-medium) var(--mw-ease)',
  }

  return (
    <article
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`rounded-3xl p-7 md:p-8 border h-full flex flex-col ${className}`}
      style={style}
    >
      <p
        style={{
          fontSize: '11px',
          fontWeight: 500,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--mw-accent)',
          fontFamily: 'var(--mw-font-body)',
          margin: 0,
        }}
      >
        {eyebrow}
      </p>
      <h3
        style={{
          fontFamily: 'var(--mw-font-display)',
          fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
          fontWeight: 600,
          letterSpacing: '-0.02em',
          color: 'var(--mw-ink)',
          lineHeight: 1.2,
          margin: '0.625rem 0 0',
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontFamily: 'var(--mw-font-body)',
          fontSize: '0.9375rem',
          color: 'var(--mw-ink-secondary)',
          lineHeight: 1.55,
          margin: '0.75rem 0 1.5rem',
        }}
      >
        {description}
      </p>
      <div className="mt-auto">{mockup}</div>
    </article>
  )
}
